<template>
  <div class="main-body">
    <div class="header">物品出入库记录</div>
    <div class="out">
      <div class="search2">

        <download-excel
            class = "export-excel-wrapper"
            :fetch           = "fetchData"
            :fields          = "json_fields"
            :before-generate = "startDownload"
            :before-finish   = "finishDownload"
            name = "物品出入库记录.xls"
            style="display: inline-block;">
          <el-button type="success" plain size="mini">导出</el-button>
        </download-excel>

        <div style="float:right;">

          <el-select v-model="institutionCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-button size="mini" style="margin-left:5px;float:right" plain type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th" border>

        <el-table-column prop="stockinRemarks" label="入库备注"></el-table-column>
        <el-table-column prop="stockinCreateTime" label="入库时间" :formatter="timefilter"></el-table-column>
        <el-table-column prop="waresName" label="物品名称"></el-table-column>
        <el-table-column prop="stockinWaresCount" label="入库数量"></el-table-column>
        <el-table-column prop="stockinWaresExpiresTime" label="过期时间" :formatter="timefilter"></el-table-column>
        <el-table-column prop="stockoutCreateTime" label="出库时间" :formatter="timefilter"></el-table-column>
        <el-table-column prop="stockoutWaresCount" label="出库数量"></el-table-column>
        <el-table-column prop="waresCountNow" label="当前库存"></el-table-column>


      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: "Role",
  data(){
    return{
      loading:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      th:0,

      arr_ins:[],
      institutionCode: '',


      showModal:false,
      json_fields: {

        "入库备注": "stockinRemarks",
        "入库时间": {
          field:"stockinCreateTime",
          callback:value=>{
            return timefilters(value);
          }
        },
        "物品名称": "waresName",
        "入库数量": "stockinWaresCount",
        "过期时间": {
          filed:"stockinWaresExpiresTime",
          callback:value=>{
            return timefilters(value);
          }
        },
        "出库时间": {
          field:"stockoutCreateTime",
          callback:value=>{
            return timefilters(value);
          }
        },
        "出库数量": "stockoutWaresCount",
        "当前库存": "waresCountNow",


      },

    }
  },
  components:{

  },
  created(){
    this.getIns();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{


    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:1,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.loading=true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Stockout/InOutGovPageIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        this.loading=false;
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue)
      }
    },

    async fetchData(){

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        pageIndex:1,
        pageSize:99999,
        institutionCode:this.institutionCode,
      }

      const response = await this.$axios.post(this.$shopUrl + "Stockout/InOutGovPageIns",data);
      return response.data.data.pageInfo.list;
    },
    startDownload:function (){
      this.showModal = true;
    },
    finishDownload:function (){
      this.showModal = false;
    },


  }
}
</script>

<style lang='scss' scoped>

</style>
